"use strict";

exports.__esModule = true;
exports.AlertTagSelector = AlertTagSelector;
var _react = _interopRequireDefault(require("react"));
var _Core = require("../../Core");
var _AlertTagLoader = require("../AlertTagLoader");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function getKey(input) {
  return input.id;
}
function renderItemText(input) {
  return input.value;
}
function AlertTagSelector(props) {
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var selectorWithItems = function selectorWithItems(items) {
    return /*#__PURE__*/_react["default"].createElement(_Core.Selector, _extends({
      placeholder: props.multiple ? translate("AlertTagselector.placeholder.multiple", "Select Tags") : translate("AlertTagselector.placeholder.single", "Select Tag"),
      getKey: getKey,
      renderItemText: renderItemText
    }, props, {
      items: items
    }));
  };
  if (props.items) {
    return selectorWithItems(props.items);
  }
  return /*#__PURE__*/_react["default"].createElement(_AlertTagLoader.AlertTagLoader, null, function (_ref) {
    var fetching = _ref.fetching,
      data = _ref.data,
      error = _ref.error;
    if (fetching || !data) return /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null);
    if (!data || error) {
      return /*#__PURE__*/_react["default"].createElement(_Core.UhOh, {
        error: error || new Error("No data")
      });
    }
    return selectorWithItems(data.filter(function (item) {
      return item.enabled;
    }));
  });
}